import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Absence() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Absence"
          title2=""
          parentTitle="Academic"
          path="Absence"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Absence</h2>

            <div className="about-content-card">
              {/* BULLET SECTION */}
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students who have been absent from class must have the
                    reason entered in the Regularity Record stating briefly the
                    cause of the absence or delay.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    If any student becomes absent from classes IX to XII, more
                    than two days, should come with her/his parents and meet the
                    principal to enter the class.
                  </span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    All students are expected to attend class on the closing day
                    before each vacation & opening day after each vacation.
                    Those absent without prior leave will be fined at the rate
                    of RS 100/-
                  </span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Continuous absence for 15 days without leave will be
                    considered equivalent to the withdrawal of the student from
                    the school, and her/his name will be struck off from the
                    rolls. If re-admitted he/she will pay the admission fee
                    again.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    A medical certificate must be produced for absence due to
                    contagious or infectious illness.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Absence;
